"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Context = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const utils_1 = require("@obvio/utils");
const react_2 = require("react");
const createTheme_1 = require("./createTheme");
const styled_1 = require("./styled");
const GlobalStyles_1 = require("../lib/GlobalStyles");
exports.Context = (0, react_2.forwardRef)(RenderContext);
function RenderContext(_a, ref) {
    var { name, children, render } = _a, rest = __rest(_a, ["name", "children", "render"]);
    const theme = (0, react_1.useTheme)();
    const context = (0, react_2.useMemo)(() => !name || theme.context === name
        ? undefined
        : (0, createTheme_1.getThemeContext)(name, theme), [name, theme]);
    const isFragemnt = !render;
    const { Tag, props = null } = isFragemnt
        ? { Tag: react_2.Fragment }
        : { Tag: render, props: Object.assign(Object.assign({}, rest), { ref }) };
    const ctxDef = name && theme._context[name];
    const hasNewGlobals = !!ctxDef && (0, utils_1.keys)(ctxDef).some((k) => ['font'].includes(k));
    if (hasNewGlobals) {
        if (props && !isFragemnt) {
            props.css = (0, styled_1.css) `
        & {
          ${() => (0, GlobalStyles_1.getContextStyles)(ctxDef)}
        }
      `;
        }
        else {
            return ((0, jsx_runtime_1.jsxs)("pre", { children: ['<', "Context name=\"", name, "\"", '>', " includes some global styles. You must provide `render` prop for them to take effect."] }));
        }
    }
    const content = props ? ((0, jsx_runtime_1.jsx)(Tag, Object.assign({}, (!isFragemnt && props), { children: children }))) : (children);
    return context ? ((0, jsx_runtime_1.jsx)(react_1.ThemeProvider, Object.assign({ theme: context }, { children: content }))) : (content);
}
